import styled from 'styled-components';
import { SColumn } from 'styles/layout';

export const SEmptyAddInfoWrapper = styled(SColumn)`
    align-items: center;
    margin: 5rem 0;
    gap: 2.5rem;
`;
